var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.08em;}.cls-1,.cls-2{font-size:65.15px;}.cls-1,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:#231f20;font-family:GoodDogNew, 'GoodDog New';}.cls-2{letter-spacing:-1em;}.cls-9{letter-spacing:-.07em;}.cls-10{font-size:37.78px;letter-spacing:0em;}.cls-11{letter-spacing:-.08em;}.cls-12,.cls-5,.cls-13{font-size:59.58px;}.cls-4,.cls-14,.cls-6{font-size:52.12px;}.cls-14{letter-spacing:-.03em;}.cls-5{letter-spacing:-.07em;}.cls-6{letter-spacing:.18em;}.cls-7{font-size:42px;letter-spacing:-.41em;}.cls-8{font-size:37px;letter-spacing:-.39em;}.cls-13{letter-spacing:0em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(9.64 68.48) rotate(-14.03) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(29.06 70.44) rotate(-24) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(32.57 66.91) rotate(-11.61) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "d"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(57.73 82.77) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 23.41,
    y: 37.22
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(87.22 97.26) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 21.42,
    y: 10.05
  }, "u"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(135.37 101.08) rotate(-11.03) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "n"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(53.62 129.21) rotate(8.2) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Z"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(79.69 130.43) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 22.78,
    y: 11.01
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.12,
    y: -5.13
  }, "e"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fb6483eaeebee43e09dd3ed827f3c16.svg";
export { ForwardRef as ReactComponent };